import EntitySwitcher, { EntitySwitcherProps } from './EntitySwitcher';
import { getAccount } from 'Hooks/Api/apiAccount';
import { store } from 'Models/Store';

export default function OrganisationContextSwitcher(props: EntitySwitcherProps) {
	const {
		getOptions,
		setValue,
		value,
	} = props;

	const requestOptions = {
		headers: {
			impersonatingOrganisationId: value,
		},
	};

	async function handleAfterSet() {
		try {
			const response = await getAccount(requestOptions);
			store.setLoggedInUser(response.data);
		} catch (err) {
			console.error(`Error updating user store.`);
		}
	}

	return (
		<div className='organisation-context-switcher'>
			<EntitySwitcher
				label={`Impersonate Organisation  `}
				objectName="organisation"
				value={value}
				setValue={setValue}
				getOptions={getOptions}
				handleAfterSet={handleAfterSet}
			/>
		</div>

	);
}
